import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	textDefaultStyles,
	resetButton,
} from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidBorderRadius,
	fluidBorderWidth,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj({
		'.supt-gdprCategory__tab': cssObj(
			fluidBorderWidth(styles?.tab?.border?.width),
			fluidBorderRadius(styles?.tab?.border?.radius),
			{
				background: styles?.tab?.backgroundColor,
				borderColor: styles?.tab?.border?.color,
			}
		),

		'.supt-gdprCategory__title': cssObj(
			fontStyle(
				{
					...styles?.tab?.title?.typography,
					textAlign: styles?.tab?.title?.textAlignment,
					color: styles?.tab?.title?.color,
				},
				false
			),
			{
				'&::before': {
					borderRight: `1px solid ${styles?.tab?.title?.color}`,
					borderBottom: `1px solid ${styles?.tab?.title?.color}`,
				},
			}
		),

		'.supt-gdprCategory__caption, .supt-gdprCategory__status': fontStyle(
			{
				...styles?.tab?.caption?.typography,
				textAlign: styles?.tab?.caption?.textAlignment,
				color: styles?.tab?.caption?.color,
			},
			false
		),

		'.supt-gdprCategory__switch': {
			'&::after': cssObj(
				fluidBorderRadius({
					/* stylelint-disable-next-line */
					topRight: styles?.tab?.border?.radius?.topRight,
					/* stylelint-disable-next-line */
					bottomRight: styles?.tab?.border?.radius?.bottomRight,
				}),
				{
					background: styles?.tab?.backgroundColor,
				}
			),
		},

		'.supt-gdprCategory__checkbox': {
			'&:checked + label': {
				backgroundColor: styles?.toggle?.enabled,
			},
		},

		'.supt-gdprCategory__desc': fontStyle(
			{
				...styles?.tab?.text?.typography,
				textAlign: styles?.tab?.text?.textAlignment,
				color: styles?.tab?.text?.color,
			},
			false
		),
	});

const getStyles = (styles) =>
	css(
		{
			'.supt-gdprCategory__tab': {
				display: 'flex',
				justifyContent: 'space-between',
				padding: '14px 12px 11px',
				cursor: 'pointer',
				position: 'relative',
				borderStyle: 'solid',

				'&:hover': {
					filter: 'brightness(95%)',
				},
			},

			'.supt-gdprCategory__title': cssObj(resetButton, {
				display: 'flex',
				alignItems: 'center',

				/* arrow */
				'&::before': {
					content: '" "',
					zIndex: 1,
					width: '7px',
					height: '7px',
					marginRight: '10px',
					marginBottom: '2px',
					flexShrink: 0,
					transform: 'rotate(-45deg)',
					transition:
						'transform 0.2s ease-in-out, border-color 0.2s ease-out',
				},
			}),

			'.supt-gdprCategory__caption': {
				marginLeft: '8px',
			},

			'.supt-gdprCategory__switch': {
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				zIndex: 10,
				marginLeft: '8px',

				'&::after': {
					content: '""',
					position: 'absolute',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 0,
					display: 'block',
					margin: '-14px -12px -11px -5px',
				},
			},

			'.supt-gdprCategory__checkbox': {
				position: 'absolute',
				zIndex: -1,

				'&:checked + label': {
					'&::before': {
						transform: 'translateX(18px)',
						backgroundColor: '#ffffff',
					},
				},

				'&:focus + label': {
					boxShadow:
						'inset #000000 0px 0px 1px 1px, #000000 0px 0px 1px 1px',
				},
			},

			'.supt-gdprCategory__label': {
				position: 'relative',
				zIndex: 1,
				height: '20px',
				width: '38px',
				order: 2,
				cursor: 'pointer',
				flexShrink: 0,

				borderRadius: '34px',
				fontSize: 0,

				boxShadow: 'none',
				backgroundColor: styles?.toggle?.disabled,
				transition:
					'background-color 0.2s ease-out, box-shadow 0.2s ease-out',

				'&::before': {
					content: '""',
					position: 'absolute',
					top: 'calc(50% - 7px)',
					left: '3px',
					display: 'block',
					height: '14px',
					width: '14px',
					borderRadius: '50%',
					backgroundColor: 'transparent',
					border: '2px solid #ffffff',
					transition:
						'background-color 0.2s ease-out, transform 0.2s ease-out',
				},
			},

			'.supt-gdprCategory__status': {
				position: 'relative',
				zIndex: 1,
				order: 1,
				marginRight: '10px',
			},

			'.supt-gdprCategory__content': {
				width: '100%',
				padding: '15px 20px 5px',

				'&[aria-hidden="true"]': {
					display: 'none',
				},
			},

			'.supt-gdprCategory__desc': textDefaultStyles,

			/**
			 * STATES
			 */
			'&.supt-isExpanded': {
				'.supt-gdprCategory__title::before': {
					transform: 'translateY(-2px) rotate(45deg)',
				},
			},
		},
		getDynamicStyles(styles)
	);

export { getStyles };
